import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SpliProvider, webTokenStorage } from "@spli/app-logic";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { ADS_CONFIG, API_BASE_URL } from "./config.js";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
if (!container) throw new Error("#root が見つかりません");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SpliProvider baseUrl={API_BASE_URL} storage={webTokenStorage()} ads={ADS_CONFIG}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SpliProvider>
    </QueryClientProvider>
  </StrictMode>,
);
